module.exports = __webpack_public_path__ + "static/media/th-vault--front.af30fc55.svg";